import React from 'react';
import { cn } from '@/lib/utils';

interface PMVBadgeProps {
  value: number | null;
  status?: string;
  className?: string;
  isAlarm: boolean;
}

export function PMVBadge({ value, isAlarm, status, className }: PMVBadgeProps) {
  if (value === null || value === undefined) return <span className="text-dark-grey">-</span>;

  // Format the value to 1 decimal place
  const formattedValue = value.toFixed(1);

  // Determine color based on PMV range
  let rangeColor = '';
  if (!isAlarm) { // Only apply range colors if not in alarm state
    if (value > 1.0) {
      rangeColor = 'text-dark-orange bg-[rgba(234,102,63,0.2)]'; // Red for hot
    } else if (value < -1.0) {
      rangeColor = 'text-dark-blue bg-[rgba(139,198,255,0.3)]'; // Blue for cold
    } else {
      rangeColor = 'text-dark-green bg-[rgba(89,209,206,0.2)]'; // Green for comfortable
    }
  }

  return (
    <span className={cn(
      "px-1.5 py-1 paragraph-11 rounded bg-bg text-dark-grey font-inter",
      status === 'on' && !rangeColor && "text-primary bg-light-grey",
      status === 'off' && !rangeColor && "text-[#B4B4B4] bg-[#F0F0F0]",
      isAlarm && "text-black-orange bg-[#F4CEC5]",
      rangeColor, // Apply range color if available
      className
    )} style={{ fontFamily: 'Inter, sans-serif !important' }}>
      {formattedValue}
    </span>
  );
}